import resourcesJp from "./namespace/ja/resource.json";

/**
 * 最初から持つ翻訳。日本語は fallbackLng でもあるので同梱し、
 * ほかの言語は表示するときに i18n/index.ts の backend で読み込む
 */
const resources = {
  ja: {
    translation: resourcesJp,
  },
};

export default resources;
